import { useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";
import { useNavigation } from "../../context/NavigationContext";
import { useMyWorkMode } from "../../hooks/useMyWorkMode";
import { getRequestSubmitHint } from "../../utils/requestHelpers";
import {
  filterRequestHubTabs,
  resolveRequestHubTab,
} from "../../utils/requestHubTabs";
import LeaveRequestForm from "./LeaveRequestForm";
import OvertimeRequestForm from "./OvertimeRequestForm";
import AdvanceRequestForm from "./AdvanceRequestForm";
import WfhRequestForm from "./WfhRequestForm";
import "./MyRequestsHub.css";

function MyRequestsHub() {
  const { user } = useAuth();
  const flags = useFeatureFlags();
  const { workMode, resolved: workModeResolved } = useMyWorkMode();
  const navigation = useNavigation();
  const requestTab = navigation?.requestTab || "leave";
  const userRole = user?.role;
  const backendRoles = user?.backendRoles;

  const tabs = useMemo(
    () =>
      filterRequestHubTabs({
        flags,
        workMode,
        workModeResolved,
        requestTab,
        user: { role: userRole, backendRoles },
      }),
    [flags, workMode, workModeResolved, requestTab, userRole, backendRoles],
  );

  const tab = resolveRequestHubTab(requestTab, tabs);

  function selectTab(id) {
    if (id === requestTab) return;
    if (navigation?.setRequestTab) {
      navigation.setRequestTab(id);
      return;
    }
    navigation?.navigate?.("leave", { tab: id });
  }

  const hintKey = tab === "advance" ? "advance" : undefined;

  return (
    <>
      <div className="ess-home-header">
        <h1 className="ess-home-title">طلباتي</h1>
        <p className="ess-home-subtitle">{getRequestSubmitHint(user?.role, hintKey)}</p>
      </div>

      {tabs.length > 1 ? (
        <div className="ess-request-tabs" role="tablist" aria-label="أنواع الطلبات">
          {tabs.map((entry) => (
            <button
              key={entry.id}
              type="button"
              role="tab"
              aria-selected={tab === entry.id}
              className={`ess-request-tab ${tab === entry.id ? "is-active" : ""}`}
              onClick={() => selectTab(entry.id)}
            >
              {entry.label}
            </button>
          ))}
        </div>
      ) : null}

      {tab === "leave" && <LeaveRequestForm />}
      {tab === "overtime" && <OvertimeRequestForm />}
      {tab === "advance" && <AdvanceRequestForm />}
      {tab === "wfh" && <WfhRequestForm />}
    </>
  );
}

export default MyRequestsHub;
